@if (showNavigation()) {
  <app-header></app-header>
}

@if (!isLoadingUser()) {
  <router-outlet></router-outlet>
}

@if (isLoadingUser()) {
  <div class="overflow-y-auto height-without-bar lg:h-full">
    <div class="w-full h-full flex justify-center items-center">
      <div class="spinner-border custom-big-spinner border-white" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
}

@if (!isBadUserAgent()) {
  <app-pwa-popup (userResponse)="handleUserResponse($event)" [installPWA]="addToHomeScreen"
  [showModal]="showModal()"></app-pwa-popup>
}
@if (showNavigation()) {
  <app-page-tabbar class="lg:hidden">
  </app-page-tabbar>
}
